enum ExtractionNodeType {
    TREE = 'tree',
    LEAF = 'leaf',
    ARTICLE = 'article',
}

export default ExtractionNodeType;
